'use strict';

import moment from 'moment-timezone';

angular.module('docketbook')
  .controller('companySettingsTemplatesController', function (docketService, resourceService, $scope, $window, Restangular, splitListInterface, $state, $stateParams, accessControl, uuid, $q, Upload) {
    mixpanel.track("Opened CompanySettings-Templates Desktop");

    $scope.currentUser = $state.params.currentUser;
    $scope.currentState = $state.current;
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.isSampleCompany = accessControl.isSampleCompany();

    $scope.moment = moment;

    $scope.goTo = function (href) {
      $window.location.href = href;
    }

    /************************/
    /**** List Controls *****/
    /************************/

    $scope.loadTemplateList = function () {
      $scope.promise = $q(function (resolve, reject) {
        // Get templates from docketService
        docketService.getTemplates(null, function (templates) {
          $scope.allTemplates = templates;
          resolve('Done');
        }, function (error) {
          $scope.allTemplates = [];
          reject('Error');
        });
      });
    }

    $scope.loadTemplateList();

    /****************************/
    /***** Detail Controls ******/
    /****************************/

    $scope.openTemplate = function (template) {
      $state.go('docketDesigner', { templateId: template.id, orgId: $scope.currentOrg.id });
    }

    $scope.openTemplateConfigure = function (template) {
      $state.go('docketDesigner', { templateId: template.id, orgId: $scope.currentOrg.id, mode: 'configure' });
    }

    $scope.newTemplate = function () {
      $state.go('docketDesigner', { templateId: 'new', orgId: $scope.currentOrg.id });
    }

    $scope.duplicateTemplate = function (template) {
      var newTemplate = angular.copy(template);
      delete newTemplate.id;
      newTemplate.name = newTemplate.name + " Copy";
      template.loading = true;

      docketService.saveTemplate(newTemplate, function (templateSaved) {
        template.loading = false;
        $scope.loadTemplateList();
      }, function (err) {
        $scope.alertService.presentAutoAlert('saveTemplate', err);
      });
    }

    $scope.deleteTemplate = function (template) {
      event.preventDefault();
      swal({
        title: "Are you sure?",
        text: "You will not be able to recover this template!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: false,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          docketService.deleteTemplate(template.id, function () {
            swal("Deleted!", "The template has been deleted.", "success");
            $scope.loadTemplateList();
          }, function (err) {
            $scope.alertService.presentAutoAlert('deleteTemplate', err);
          });
        }
      });
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/companySettings/templates.js